import { format } from "@hejdoktor/resx-compiler"
const pluralRules = new Intl.PluralRules("da")

export const R = {
	"Name1": "this is my long string",
	"Bitmap1": "[base64 mime encoded serialized .NET Framework object]",
	"Icon1": "[base64 mime encoded string representing a byte array form of the .NET Framework object]",
	"CallIssueCamera": "Der er problemer med at tilgå dit kamera.",
	"CallIssueMicrophone": "Der er problemer med at tilgå din mikrofon.",
	"CallIssueNetwork": "Der er problemer med netværksforbindelsen.",
	"CallIssueReconnectQuestion": "Vil du prøve at forbinde igen?",
	"CallIssueTitle": "Noget er galt",
	"CallQualityFeedback_Bad": "Dårligt",
	"CallQualityFeedback_Ok": "Godt!",
	"CallQualityFeedback_Title": "Hvordan virkede video-teknikken?",
	"CallReJoinButton": "Tilslut igen",
	"Camera": "Kamera",
	"CameraOffTooltip": "Tænd kamera",
	"CameraOnTooltip": "Sluk kamera",
	"Close": "Luk",
	"Connected": "Forbundet",
	"Connecting": "Forbinder...",
	"DeviceSelectionDropdownCameraPlaceholderChoose": "Vælg kamera",
	"DeviceSelectionDropdownCameraPlaceholderEmpty": "Ingen kameraer fundet",
	"DeviceSelectionDropdownMicrophonePlaceholderChoose": "Vælg mikrofon",
	"DeviceSelectionDropdownMicrophonePlaceholderEmpty": "Ingen mikrofon fundet",
	"DeviceSelectionDropdownSpeakerPlaceholderChoose": "Vælg højtaler",
	"DeviceSelectionDropdownSpeakerPlaceholderEmpty": "Ingen højtalere fundet",
	"DeviceSelectionDropdownSpeakerPlaceholderSystemDefault": "Systemstandard",
	"DeviceSetupCameraPermissionDeniedHint": "For at deltage i videokonsultationen skal du give adgang til dit kamera.",
	"DeviceSetupContinue": "Tilslut dig",
	"DeviceSetupDone": "Færdig",
	"DeviceSetupHelpLink": "Har du brug for hjælp?",
	"DeviceSetupMicrophoneHint": "Bevæger mikrofon-bjælken sig, når du taler? Så er din mikrofon korrekt tilsluttet.",
	"DeviceSetupMicrophonePermissionDeniedHint": "For at deltage i videokonsultationen skal du give adgang til din mikrofon.",
	"DeviceSetupPermissionDeniedModalDescription": "Giv hejdoktor.dk tilladelse til at bruge dit kamera og mikrofon.",
	"DeviceSetupPermissionDeniedModalDescriptionDisclaimer": "Du kan slukke for lyd og video inde i videoopkaldet.",
	"DeviceSetupPermissionDeniedModalDescriptionReloadInstruction": "Genindlæs siden når du er færdig.",
	"DeviceSetupPermissionDeniedModalTitle": "Adgang til kamera og mikrofon er blokeret",
	"DeviceSetupSpeakerTest": "Afspil lyd",
	"DeviceSetupSubtitle": "Tjek dine indstillinger for højtalere, mikrofon og kamera. Klik på \"tilslut dig\" når du er klar til at starte videokonsultationen.",
	"DeviceSetupTitle": "Deltag i videokonsultationen",
	"DeviceSetupTitleSetupOnly": "Test dine indstillinger",
	"Disconnected": "Afbrudt",
	"Disconnecting": "Afbryder",
	"DoYouWantToEndTheCall": "Du er den sidste her",
	"ErrorCallQualityFeedback": "Kunne ikke gemme din feedback",
	"Ignore": "Ignorer",
	"LeavingCall": "Afslutter...",
	"LocalPreviewCameraOff": "Kamera slukket",
	"Microphone": "Mikrofon",
	"MicrophoneOffTooltip": "Tænd mikrofon",
	"MicrophoneOnTooltip": "Sluk mikrofon",
	"PhoneCallPopupDescription": "Du er ved at ringe patienten op via telefon. Du kan stadig benytte video til at vurdere patientens problematik.",
	"PhoneCallPopupEndCallButtonText": "Afbryd telefonopkald",
	"PhoneCallPopupTitleConnected": "Telefonopkald er i gang",
	"PhoneCallPopupTitleConnecting": "Ringer til patienten",
	"Reconnect": "Forbind igen",
	"Reconnecting": "Forsøger at forbinde igen",
	"ScreenShareOffTooltip": "Start skærmdeling",
	"ScreenShareOnTooltip": "Stop skærmdeling",
	"Settings": "Indstillinger",
	"SettingsTooltip": "Indstillinger",
	"Speaker": "Højtaler",
	"StartPhoneCall": "Start telefonopkald",
	"StartPhoneCallTooltip": "Opstår der tekniske udfordringer, kan du ringe op til patienten via telefon.",
	"Starting": "Starter",
	"VideoLoadingTooltip": "Kamera starter",
	"YouAreTheLastOneHere": "Du er den sidste her",
	"WaitingForDoctor": "Venter på {0}",
	"BackToConsultations": "Tilbage til mine konsultationer",
	"ApproxWaitingTime": (number: number, { minimumFractionDigits = 0, maximumFractionDigits = 3 }: { minimumFractionDigits?: number, maximumFractionDigits?: number } = {}) => {
		const nf = new Intl.NumberFormat("da", { minimumFractionDigits, maximumFractionDigits })
		switch(pluralRules.select(number)) {
			case "one":
				return format("Ventetiden er ca. 1 minut.", nf.format(number))
			default:
			case "other":
				return format("Ventetiden er ca. {0} minutter.", nf.format(number))
		}
	},
	"Excellent": "Fremragende",
	"Good": "God",
	"Bad": "Dårlig",
	"Unknown": "Ukendt",
	"Connection": "Forbindelse",
	"NetworkStatus": "Netværksstatus",
	"WaitingForPatient": "Venter på patienten",
	"DeviceCameraPermissionDeniedModalDescriptionFirstStep": "Luk eksterne programmer, der måske bruger dit kamera.",
	"DeviceCameraPermissionDeniedModalDescriptionSecondStep": "Hvis du bruger et eksternt kamera, så prøv at frakoble og tilslutte det igen.",
	"DeviceCameraPermissionDeniedModalDescriptionThirdStep": "Luk og åbn din browser igen.",
	"DeviceMicrophonePermissionDeniedModalDescriptionFirstStep": "Luk eksterne programmer, der måske bruger din mikrofon.",
	"DeviceMicrophonePermissionDeniedModalDescriptionSecondStep": "Hvis du bruger en ekstern mikrofon, så prøv at frakoble den og tilslutte den igen.",
	"DeviceMicrophonePermissionDeniedModalDescriptionThirdStep": "Luk og åbn din browser igen.",
	"DeviceSetupPermissionDeniedModalDescriptionFirstStep": "Luk eksterne programmer, der måske bruger dit kamera/mikrofon.",
	"DeviceSetupPermissionDeniedModalDescriptionSecondStep": "Hvis du bruger et eksternt kamera/mikrofon, så prøv at frakoble det og tilslutte det igen.",
	"DeviceSetupPermissionDeniedModalDescriptionThirdStep": "Luk og åbn din browser igen.",
	"DeviceCameraPermissionDeniedModalDescription": "Giv hejdoktor.dk tilladelse til at bruge dit kamera.",
	"DeviceMicrophonePermissionDeniedModalDescription": "Giv hejdoktor.dk tilladelse til at bruge din mikrofon.",
	"DeviceCameraPermissionDeniedModalDescriptionDisclaimer": "Du kan slukke for video inde i videoopkaldet.",
	"DeviceMicrophonePermissionDeniedModalDescriptionDisclaimer": "Du kan slukke for lyd inde i videoopkaldet.",
	"DeviceCameraPermissionDeniedModalTitle": "Adgang til kamera er blokeret",
	"DeviceMicrophonePermissionDeniedModalTitle": "Adgang til mikrofon er blokeret",
	"ChooseBackground": "Vælg en baggrund",
	"AddBackground": "Tilføj baggrund",
	"Blur": "Sløring",
	"None": "Ingen",
	"NoAnswerInfoHeader": "Kunne du ikke få kontakt med patienten?",
	"NoAnswerInfoText": "Prøv først at ringe til patienten. Hvis det ikke lykkes, så send en automatiseret mail med en opfordring til at booke en ny tid.",
	"Call": "Ring op",
	"SendMail": "Send mail",
	"EmailSent": "Mailen er blevet sendt til patienten",
	"ErrorSentEmail": "FEJL: Kunne ikke sende mail til patienten.",
	"TechnicalIssues": "Var der problemer med teknikken?",
	"EndVideo": "Afslut video",
}